const generateData = (rows, query) => {
  const newData = rows.map((row, key) => ({
    num: query?.page * query?.pageSize + key + 1,
    invoiceId: row.cols[0], // 1349 شناسه فاکتور
    issueDate: row.cols[1], // تاریخ صدور
    issueTime: row.cols[2], // زمان صدور
    tax: row.cols[3], // مالیات
    amountPayable: row.cols[4], // مبلغ قابل پرداخت
    dateOfPayment: row.cols[5], // تاریخ پرداخت
    timeOfPayment: row.cols[6], // زمان پرداخت
    invoiceStatus: row.cols[7], // وضعیت فاکتور
    guildName: row.cols[8], // نام حساب تفصیلی کسب‌وکار
    decreased: row.cols[9], // کاهش یافته
    1355: row.cols[10], // شناسه فاکتور کاهش یافته
    hasMultiInvoice: row.cols[11], // تسهیم
    1385: row.cols[12], // شناسه فاکتور اصلی
    mainMultiInvoice: row.cols[13], // فاکتور اصلی تسهیمی
    guildId: row.cols[14], // شناسه حساب تفصیلی کسب‌وکار,
    paymentMethod: row.cols[22],
    cardNumber: row.cols[18],
    shaparakPayment: row.cols[24],
    payable: row.cols[25],
    userId: row.cols[15],
  }));

  return newData;
};

export default generateData;
